import { useCallback } from 'react';
import { FieldGroupFragment as FieldGroup, Field } from 'generated/graphql';

const useRemoveFieldGroup = ({
  fieldGroups,
  groupIndex,
  onFieldUpdateNew,
  numOfGroups,
  setNumOfGroups,
}: {
  fieldGroups: FieldGroup[];
  groupIndex: number;
  onFieldUpdateNew: (
    fieldGroup: Field[],
    field: Field,
    value: string,
    values?: string[],
    entityID?: string,
  ) => Promise<void>;
  numOfGroups?: number;
  setNumOfGroups?: (numOfGroups: number) => void;
}) => {
  const onFieldShiftDeleteGroup = useCallback(() => {
    if (!numOfGroups || !setNumOfGroups) return;

    fieldGroups.slice(groupIndex, numOfGroups).forEach((group, grpIndex, groupsArray) => {
      group.fields.forEach((field, fldIndex, fields) => {
        if (grpIndex === numOfGroups - 1) {
          onFieldUpdateNew(fields, field, '', []);
        } else {
          onFieldUpdateNew(
            fields,
            field,
            groupsArray[grpIndex + 1]?.fields[fldIndex].value ?? '',
            groupsArray[grpIndex + 1]?.fields[fldIndex].values ?? [],
          );
        }
      });
    });

    setNumOfGroups(numOfGroups - 1);
  }, [fieldGroups, groupIndex, numOfGroups, onFieldUpdateNew, setNumOfGroups]);

  const onDeleteGroup = useCallback(async () => {
    onFieldShiftDeleteGroup();
    return true;
  }, [onFieldShiftDeleteGroup]);

  return { onDeleteGroup };
};

export default useRemoveFieldGroup;
